import { db, auth } from '../../plugins/firebase'

const state = {
    schedules:[],
    collection: 'schedules'
}

const getters = {
    getSchedule: state => schedule => state.schedules.find( s => s.id == schedule ),
    getAll: state => state.schedules.map( s => ({ name: s.name, id: s.id })),
}

const actions = {
    async setCollectionDb({ commit, dispatch }){
        return new Promise(async (resolve, reject) =>{
            if(auth.currentUser){
                await dispatch('fetchUserSchedules', auth.currentUser.uid)
                return resolve()
            }else{
                commit('SET_SCHEDULES', [])
                return resolve()
            }
        })
    },
    async fetchUserSchedules({ state, commit }, user){
        return new Promise(async (resolve, reject) =>{
            try {
                let schedules = await db.collection(state.collection).where('user_id', "==", user).get()
                if(!schedules.docs) return resolve()
                commit('SET_SCHEDULES', schedules.docs.map( doc => ({ ...doc.data(), id: doc.id } )))
                return resolve()
            } catch (error) {
                console.log(error)
                commit('SET_SCHEDULES', [])
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    addSchedule({ state, commit }, schedule){
        return new Promise(async (resolve, reject) => {
            try {
                schedule.user_id =  auth.currentUser.uid
                let res = await db.collection(state.collection).add(schedule)
                schedule.id = res.id
                commit('ADD_SCHEDULE', schedule)
                resolve()
            } catch (error) {
                console.log(error)
                reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    updateScheduleData({ state, commit }, data) {
        return new Promise(async (resolve, reject) => {
            try {
                let indexSchedule = state.schedules.findIndex( s => s.id == data.schedule )
                if(indexSchedule < 0) return reject({ message: 'Horario no encontrado' })

                let res = await db.doc(`${state.collection}/${data.schedule}`).update(data.props)
                
                commit('UPDATE_SCHEDULE', { 
                    index: indexSchedule,
                    data: data.props
                })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    updateScheduleGateways({ state, commit }, data){
        return new Promise(async (resolve, reject) => {
            try {
                let indexSchedule = state.schedules.findIndex( s => s.id == data.schedule )
                if(indexSchedule < 0) return reject()

                let res = await db.doc(`${state.collection}/${data.schedule}`).update({
                    gateways: data.gateways
                })

                commit('UPDATE_SCHEDULE', { 
                    index: indexSchedule,
                    data: { gateways: data.gateways }
                })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    deleteSchedule({ state, commit }, schedule_id) {
        return new Promise(async (resolve, reject) => {
            try {
                let indexSchedule = state.schedules.findIndex( s => s.id == schedule_id )
  
                if(indexSchedule < 0) return reject({ message: 'Horario no encontrado' })
                let res = await db.doc(`${state.collection}/${schedule_id}`).delete()
                
                commit('DELETE_SCHEDULE', { 
                    index: indexSchedule
                })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
}

const mutations = {
    ADD_SCHEDULE(state, schedule){
        state.schedules.push(schedule)
    },
    SET_SCHEDULES(state, schedules){
        state.schedules = schedules
    },
    DELETE_SCHEDULE(state, payload){
        if(payload.index == undefined) return
        state.schedules.splice(payload.index, 1)
    },
    UPDATE_SCHEDULE(state, payload){
        if(payload.index == undefined || payload.index == -1) return

        Object.entries(payload.data).forEach( prop => {
            state.schedules[payload.index][prop[0]] = prop[1]
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}